import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { Button, NavBar, Tab, Tabs, List, Cell, CellGroup, Card, Tag, Image as VanImage, Loading, Toast, Tabbar, TabbarItem, Icon, Popup, DropdownMenu, DropdownItem, Field, IndexBar, IndexAnchor, Swipe, SwipeItem, Search, Sticky, Pagination } from 'vant'
import 'vant/lib/index.css'
// 引入全局样式
import './styles/index.less'
// 引入 vue-seamless-scroll
import vueSeamlessScroll from 'vue-seamless-scroll'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import http from './utils/request'
import { loadFulltext, getText } from './utils/i18n'
import { getLanguage } from './utils/lang'
Vue.prototype.$http = http
Vue.prototype.$t = getText

// 多语言站点各自独立域名部署，<html lang> 需跟随构建语言（否则 4 个站都写死 en）
document.documentElement.setAttribute('lang', getLanguage())

// 注册 Vant 组件
Vue.use(Search)
Vue.use(Button)
Vue.use(NavBar)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(List)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Card)
Vue.use(Tag)
Vue.use(VanImage)
Vue.use(Loading)
Vue.use(Toast)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Icon)
Vue.use(Popup)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Field)
Vue.use(IndexBar)
Vue.use(IndexAnchor)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Sticky)
Vue.use(Pagination)
Vue.use(vueSeamlessScroll)
Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')